
import { generateAesCrypto, generateRandomByte, getNonceAPIHandler } from '@/composables/aes'
import { useRecaptcha } from '@/composables/recaptcha'
import { useStorage } from '@/composables/storage'
import { HappyRedPacketContract, RedPacketContract } from '@/contract/func/redPacket'
import { HappyRedPacket } from '@/contract/helper/abi/HappyRedPacket'
import { ethers, providers } from 'ethers'
import { computed, defineComponent, onMounted, PropType, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import PersonalityButton from '../common/PersonalityButton.vue'
import type { State as WalletState } from '@/store/wallet'

export default defineComponent({
  components: { PersonalityButton },
  name: 'List',
  props: {
    data: {
      type: Object as PropType<any>,
      required: true
    },
    provider: {
      type: Object as PropType<ethers.providers.Web3Provider>,
      required: true
    },
    contractAddress: {
      type: String,
      required: true
    },
    tokenInfo: {
      type: Object,
      required: true
    },
    chainId: {
      type: String,
      required: true
    },
    refundSuccessCallback: {
      type: Function
    }
  },

  emits: ['refundSuccess'],

  setup (props, { emit }) {
    const router = useRouter()
    const store = useStore()

    const storage = useStorage()

    const recaptcha = useRecaptcha()

    const refundLoading = ref(false)

    /**
     * 检测是否已领取完
     */
    const isReceiveFinish = (count: number, receivedCount: number) => {
      return count === receivedCount
    }

    const isReceiveExpired = computed(() => {
      return Date.now() >= props.data.expiredDate
    })

    const isReceivedAmount = (val: string) => {
      return {
        value: Number(val) > 0 ? 'Expired' : 'Finished',
        status: Number(val) > 0
      }
    }

    const redpackContract = computed(() => {
      return store.state.contractRedpack.contract as HappyRedPacketContract
    })

    const wallet = computed(() => {
      return store.state.wallet.wallet as WalletState['wallet']
    })

    function txData () {
      const params = [
        props.data.envelopeId
      ]

      return redpackContract.value.encode('refund', params)
    }

    async function sendTx (txParams: providers.TransactionRequest) {
      if (wallet.value) {
        try {
          const { gasPrice, gasLimit } = await wallet.value.gasFee(txParams)

          const tx = await wallet.value.signer.sendTransaction({
            ...txParams,
            gasPrice,
            gasLimit
          })

          const txResult = await wallet.value.provider.waitForTransaction(tx.hash)

          if (txResult.status === 0) {
            throw txResult.logs
          }
        } catch (err) {
          console.log('createRedPackHandler', err)
        }
      }
    }

    /**
     * 回收红包
     */
    async function refundRedPack () {
      try {
        refundLoading.value = true

        const data = txData()

        const txParams: providers.TransactionRequest = {
          to: redpackContract.value.contract.address,
          data
        }

        await sendTx(txParams)

        if (props.refundSuccessCallback) {
          await props.refundSuccessCallback()
        }

        refundLoading.value = false
      } catch (error) {
        console.log(error)

        refundLoading.value = false
      }
    }

    async function routeViewRecords () {
      if (props.data.receivedCount === props.data.count || props.data.expiredDate <= Date.now()) {
        router.push({
          name: 'ViewRecords',
          query: {
            redPackId: props.data.envelopeId,
            skin: props.data.type
          }
        })
      } else {
        const routeParams: {
          chainId: string
          redPackId: string
          chainIdInit: string
          skin: string
          nonce?: string
        } = {
          chainId: props.tokenInfo.chainType,
          redPackId: props.data.envelopeId,
          chainIdInit: props.chainId,
          skin: props.data.type
        }

        const inputResult = storage.findRedpackInput({
          id: props.data.envelopeId
        })

        let input

        if (inputResult) {
          console.log('inputResult yes', inputResult)

          input = generateAesCrypto(inputResult.msg)
        } else {
          console.log('inputResult no')

          const msg = generateRandomByte().toString()

          input = generateAesCrypto(msg)

          storage.saveRedpackInput({
            id: props.data.envelopeId,
            msg,
            expire: props.data.expiredDate
          })
        }
        const captcha = await recaptcha.execute('record')

        const nonce = await getNonceAPIHandler(props.data.envelopeId, props.chainId, captcha, input)

        routeParams.nonce = nonce

        router.push({
          name: 'ReceiveRedPack',
          query: routeParams
        })
      }
    }

    return {
      publicPath: process.env.BASE_URL,
      isReceivedAmount,
      refundRedPack,
      isReceiveFinish,
      isReceiveExpired,
      refundLoading,
      routeViewRecords
    }
  }
})
